// 描述：敏感词校验
// 作者：BaiZhiming
// 时间：2016-11-24
'use strict';
angular.module('sensitiveWordCheckServiceModule', []).factory('sensitiveWordCheckService', [
    'trsHttpService',
    '$q',
    '$modal',
    'modalDialog',
    'editIsLock',
    '$timeout',
    'ueditorService',
    'localStorageService',
    'editingCenterSaveCheckService',
    function(trsHttpService, $q, $modal, modalDialog, editIsLock, $timeout, ueditorService, localStorageService, editingCenterSaveCheckService) {
        // 错词级别 1：是错误， 2是疑错, 3是严重错误
        var errorLevelColor = {
            '1': '#FFA500', // 橘黄色
            '2': '#08c4c5', // 蓝色
            '3': '#FF0000', // 红色
        };
        var heimaWords = []; // 所有的黑马信息
        var docPropertys = {
            // docPropertys[name]
            LEADTITLE: '文章肩题',
            TITLE: '标题',
            HOMETITLE: '首页标题',
            SUBTITLE: '文章副题',
            HTMLCONTENT: '正文',
            LISTTITLE: '列表标题',
            JTITLE: '文章肩题',
            CONTENT: '正文',
            APPDESC: '分图说',
            FOCUSIMGTITLE: '焦点图标题',
            SPECIALCONTENT: '专题稿内容',
        };

        /**
         * [getCheckField description]hasSensitiveWords 返回结果中是否包含敏感词
         * @param  {[obj]} sensitiveWordsObj [description]敏感词对象
         * @return {[boolean]}  boolean    [description]返回将要校验的字段
         */
        function hasSensitiveWords(sensitiveWordsObj) {
            var flag = false;
            for (var i in sensitiveWordsObj) {
                if (sensitiveWordsObj[i].length > 0) {
                    flag = true;
                    break;
                }
            }
            return flag;
        }

        /**
         * [arrangeSensitiveWords description] 将敏感词整理成数组，再用逗号分隔成字符串
         * @param  {[type]} sensitiveWordsObj [description]敏感词对象
         * @return {[type]}                   [description]
         */
        function arrangeSensitiveWords(sensitiveWordsObj) {
            var sensitiveWordsArray = [];
            for (var i in sensitiveWordsObj) {
                if (sensitiveWordsObj[i].length > 0) {
                    for (var j in sensitiveWordsObj[i]) {
                        if (sensitiveWordsObj[i][j].WORDGROUPS !== '') {
                            sensitiveWordsArray.push(sensitiveWordsObj[i][j].WORDGROUPS);
                        } else {
                            sensitiveWordsArray.push(sensitiveWordsObj[i][j].SENSITIVEWORDS);
                        }
                    }
                }
            }
            return sensitiveWordsDeduplication(sensitiveWordsArray);
        }

        /**
         * [sensitiveWordsDeduplication description] 对敏感词数组进行去重复
         * @param  {[type]} sensitiveWordsArray [description]敏感词数组
         * @return {[type]}                     [description]
         */
        function sensitiveWordsDeduplication(sensitiveWordsArray) {
            var lastArray = [];
            for (var i = 0; i < sensitiveWordsArray.length; i++) {
                if (!sensitiveWordsUnique(sensitiveWordsArray[i], lastArray)) {
                    lastArray.push(sensitiveWordsArray[i]);
                }
            }
            return lastArray.join(',');
        }

        /**
         * [sensitiveWordsUnique description]
         * @param   {[type]}  data   [data description]
         * @param   {[type]}  array  [array description]
         * @return  {[type]}         [return description]
         */
        function sensitiveWordsUnique(data, array) {
            for (var j = 0; j < array.length; j++) {
                if (data == array[j]) {
                    return true;
                }
            }
            return false;
        }

        /**
         * [clearMarkSensitiveWord description] 清除敏感词校验标志
         * @param {string} [htmlContent] [description] 正文
         * @return {[type]} [description]
         */
        function clearMarkSensitiveWord(htmlContent) {
            var dom = document.createElement('div');
            dom.innerHTML = htmlContent;
            $(dom)
                .find('span.trasScale')
                .each(function() {
                    $(this).replaceWith(this.innerHTML.replace(/\(.*\)/, ''));
                });
            return dom.innerHTML;
        }

        /**
         * [getCheckField description]获取校验字段
         * @return {[obj]}  obj    [description]返回将要校验的字段
         */
        function getCheckField() {
            var checkField = '';
            // 没有编辑器的时候会报错，所以 try catch 一下
            if (window.UE) {
                var ue = UE.getEditor('ueditor');
                var dom = document.createElement('div');
                dom.innerHTML = ue.getContent();
                checkField += dom.innerText.replace(/\u00a0/g, '\u0020').replace(/　/g, '\u0020');
            }
            return checkField;
        }

        /**
         * [whetherPoliticalAuthority description]是否有政审权限
         * @return {[obj]}  obj    [description]返回将要校验的字段
         */
        function whetherPoliticalAuthority(MediaType, DocIds) {
            var deffer = $q.defer();
            var result = false;
            var params = {
                serviceid: 'mlf_metadata',
                methodname: 'checkZhengShenRight',
                MediaType: MediaType + '', // 兼容数字
                DocIds: DocIds,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                result = data == 'true';
                deffer.resolve(result);
            });
            return deffer.promise;
        }

        /**
         * [getSensitiveWordOfContent description]获取正文中的敏感词
         * @param  {[type]} content [description]需要校验的文字
         * @return {[obj]}  obj    [description]返回敏感词对象数组
         */
        function getSensitiveWordOfContent(content) {
            var dom = document.createElement('div');
            dom.innerHTML = content;
            content = dom.innerText;
            var deffer = $q.defer();
            if (content !== '') {
                var params = {
                    serviceid: 'mlf_sensitiveword',
                    methodname: 'getSensitiveWordOfContent',
                    content: content,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    deffer.resolve(data);
                });
            } else {
                deffer.resolve([]);
            }
            return deffer.promise;
        }

        /**
         * [getSensitiveWordOfDocPropertys description]获取编辑页面属性字段中的敏感词
         * @param  {[type]} docPropertys [description]需要校验的属性
         * @return {[type]}              [description]返回敏感词对象数组
         */
        function getSensitiveWordOfDocPropertys(docPropertys) {
            return;
        }

        /**
         * [replaceStrWithoutHtml description]替换敏感词为带颜色标签的敏感词
         * @param  {[string]} htmlContent [description]正文
         * @param  {[string]} sensitiveWord [description]敏感词
         * @return {[obj]}  obj    [description]返回敏感词对象数组
         */
        function replaceStrWithoutHtml(htmlContent, sensitiveWord) {
            sensitiveWord = sensitiveWord.replace(/\u0020/g, '\u3000').replace(/\u00a0/g, '\u3000');
            let sensitiveWordArray = sensitiveWord.split('');
            sensitiveWordArray.forEach((word, index) => {
                if (index == 0) {
                    return;
                }
                sensitiveWordArray[index] = '(<[^>]*>)*' + word;
            });
            let reg = new RegExp(sensitiveWordArray.join(''), 'ig');
            htmlContent = htmlContent.replace(reg, ($1, $2, $3, $4) => {
                let str = '';
                let tagArray = [];
                $1 = $1
                    .replace(/<\/?[^>]*>/g, (a) => {
                        tagArray.push(a);
                        return '$$$___replace___***';
                    })
                    .replace(/\u0020/g, '　')
                    .replace(/&nbsp;/g, '　')
                    .replace(/\u00a0/g, '　');
                let textArray = $1.split('$$$___replace___***');
                textArray.forEach((word_, index_) => {
                    if (word_ == '') {
                        return;
                    }
                    textArray[index_] = `<span class="trasScale red">${word_}</span>`;
                });
                str = textArray.join('$$$___replace___***');
                let i = 0;
                str = str.replace(/\$\$\$\_\_\_replace\_\_\_\*\*\*/g, function() {
                    return tagArray[i++];
                });
                return str;
            });

            return htmlContent;
        }


        /**
         * [markSensitiveWord description] 标记敏感词
         * @param   {[type]}  htmlContent     [htmlContent description] html正文
         * @param   {[type]}  sensitiveWords  [sensitiveWords description] 敏感词数组
         * @param   {[type]}  isPopover       [isPopover description]
         * @param   {[type]}  loopHandle      [loopHandle description]
         * @return  {[type]}                  [return description]
         */
        function markSensitiveWord(htmlContent, sensitiveWords, isPopover, loopHandle) {
            for (var i = 0; i < sensitiveWords.length; i++) {
                var sensitiveWord = sensitiveWords[i].SENSITIVEWORDS;
                if (angular.isFunction(loopHandle)) {
                    loopHandle(sensitiveWord, sensitiveWords[i]);
                }
                htmlContent = replaceStrWithoutHtml(htmlContent, sensitiveWord);
            }
            return htmlContent;
        }

        /**
         * [markFuncunWord description] 标记正文中的方寸（编辑器中）
         * @param   {[type]}  htmlContent  [htmlContent description]
         * @param   {[type]}  heimaWords   [heimaWords description] 最终获取到的校验结果对象数组
         * @param   {[type]}  callback     [callback description]
         * @return  {[type]}               [return description]
         */
        function markFuncunWord(htmlContent, heimaWords, callback) {
            var heimaWordsArr = angular.copy(heimaWords);
            var htmlTagArry = [];
            htmlContent = (function() {
                var str = htmlContent;
                str = str.replace(/<\/?[^>]*>/g, function(a) {
                    htmlTagArry.push(a);
                    return '$$$___replace___***';
                });
                return str
                    .replace(/(&nbsp;){4}/g, '　')
                    .replace(/&nbsp;/g, '')
                    .replace(/&nbsp/g, '')
                    .replace(/\"/g, '"')
                    .replace(/\'/g, "'")
                    .replace(/\&quot;/g, '"')
                    .replace(/\&#39;/g, "'")
                    .replace(/\&amp;/g, '&');
            })();

            var startPosAdd = 0;
            var markIndex = 0; // 给错误词加上标记
            var htmlContentArray = htmlContent.split('$$$___replace___***');
            for (var k = 0; k < heimaWordsArr.length; k++) {
                var wordObj = heimaWordsArr[k];
                var errorWord = wordObj.error_word;
                var offset = (wordObj.offset += startPosAdd);
                var level = wordObj.confidence;
                var index = 0;
                innerloop: for (var l = 0; l < htmlContentArray.length; l++) {
                    index += htmlContentArray[l].length;
                    if (offset >= index) {
                        // 
                    } else {
                        var endLocation = offset - (index - htmlContentArray[l].length) + errorWord.length;
                        var startLocation = offset - (index - htmlContentArray[l].length);
                        var otherInf = "trscheck corword='" + wordObj.right_words[0] + "' index='" + markIndex + "' level='" + level + "' ";
                        htmlContentArray[l] = (function(data) {
                            var dataArray = data.split('');
                            dataArray.splice(endLocation, 0, '(' + wordObj.type + ')</span>');
                            return dataArray.join('');
                        })(htmlContentArray[l]);
                        htmlContentArray[l] = (function(data) {
                            var dataArray = data.split('');
                            dataArray.splice(
                                startLocation,
                                0,
                                '<span ' + otherInf + "class='trasScale' style='color:" + errorLevelColor[level] + ";'>"
                            );
                            return dataArray.join('');
                        })(htmlContentArray[l]);
                        // startPosAdd += 36;
                        startPosAdd += 54 + otherInf.length + wordObj.type.length + 2; // 加了放大样式：trasScale
                        markIndex++;
                        break innerloop;
                    }
                }
            }
            htmlContent = htmlContentArray.join('$$$___replace___***');
            var m = 0;
            htmlContent = htmlContent.replace(/\$\$\$\_\_\_replace\_\_\_\*\*\*/g, function() {
                return htmlTagArry[m++];
            });
            callback(heimaWordsArr);
            return htmlContent;
        }

        return {

            /**
             * [markFuncunWord description] 标记方寸
             * @param   {[type]}  htmlContent    [htmlContent description] 正文
             * @param   {[type]}  heimaWordsArr  [heimaWordsArr description] 黑马数组
             * @param   {[type]}  loopHandle     [loopHandle description]
             * @return  {[type]}                 [return description] 标记完成的正文
             */
            markFuncunWord: function(htmlContent, heimaWordsArr, loopHandle) {
                return markFuncunWord(htmlContent, heimaWordsArr, loopHandle);
            },

            /**
             * [markFuncunWordCompare description] 标记并比较编辑器中的错别字校对词
             * @param {object} [scope] [description] 调用区域的作用域
             * @return {[type]}    [description]
             */
            markFuncunWordCompare: function(scope) {
                var self = this;
                if (window.UE) {
                    scope.ue = UE.getEditor('ueditor');
                    initData();
                }

                /**
                 * [initData description] 初始化错别字校对
                 * @return {[type]} [description]
                 */
                function initData() {
                    var htmlcontent = scope.ue.getContent();

                    markFuncunWord(htmlcontent);
                }

                /**
                 * [markFuncunWord description] 在编辑器中标记命中词
                 * @param   {[type]}  htmlContent  [htmlContent description]
                 * @return  {[type]}               [return description]
                 */
                function markFuncunWord(htmlContent) {
                    if (htmlContent !== '') {
                        htmlContent = ueditorService.replaceHtmlBlank(htmlContent);
                        self.getFuncunWordOfContent().then(function(heimaWordsArr) {
                            scope.heimaWordsArr = heimaWordsArr;
                            // 构造标红元素
                            htmlContent = self.markFuncunWord(htmlContent, heimaWordsArr, function(value) {
                                scope.subHeimaWordsArr = value;
                            });
                            scope.ue.setContent(htmlContent);
                        });
                    }
                }
            },

            /**
             * [getFuncunWordOfContent description]获取正文中的黑马
             * @param  {[type]} content [description]
             * @return {[type]}         [description]
             */
            getFuncunWordOfContent: function() {
                var deffer = $q.defer();
                deffer.resolve(heimaWords);
                return deffer.promise;
            },
            sensitiveWords: function($scope) {
                return editingCenterSaveCheckService.check($scope);
            },

            // 方寸敏感词校验
            sensitiveWordsForFuncun: function() {
                // var docPropertys = getCheckField();
                var deffer = $q.defer();
                deffer.resolve([]);
                return deffer.promise;
            },

            // 获取当前页面所有需要校验敏感词的输入框的敏感词
            getAllInputSensitiveWords: function() {
                var docPropertys = getCheckField();
                var deffer = $q.defer();
                getSensitiveWordOfDocPropertys(docPropertys).then(function(data) {
                    var flag = hasSensitiveWords(data);
                    if (flag) {
                        deffer.resolve(data);
                    } else {
                        deffer.resolve(flag);
                    }
                });
                return deffer.promise;
            },
            // 获取当前页面所有需要校验敏感词的输入框
            getCheckInput: function() {
                var checkField = [];
                $('*[sensitive-input]').each(function(index) {
                    var modelName = $(this).attr('ng-model');
                    var checkName = modelName.split('.')[modelName.split('.').length - 1];
                    if (checkName === 'APPDESC') {
                        checkName += '*' + (parseInt($(this).attr('s-input-index')) + 1);
                    }
                    checkField.push({
                        checkName: checkName,
                        field: $(this),
                    });
                });
                return checkField;
            },

            /**
             * [getSensitiveWordOfContent description]获取正文中的敏感词
             * @param  {[type]} content [description]需要校验的文字
             * @return {[obj]}  obj    [description]返回敏感词对象数组
             */
            getSensitiveWordOfContent: function(content) {
                var deffer = $q.defer();
                getSensitiveWordOfContent(content).then(function(data) {
                    deffer.resolve(data);
                });
                return deffer.promise;
            },

            /**
             * [getSensitiveWordOfDocPropertys description]获取各个属性中的的敏感词
             * @param  {[type]} content    [description]需要校验的文字
             * @return {[promise]}  obj    [description]返回敏感词对象数组
             */
            /**
             * [getSensitiveWordOfDocPropertys description] 获取各个属性中的的敏感词
             * @param   {[type]}  docPropertys  [docPropertys description] 需要校验的文字
             * @return  {[type]}                [return description]
             */
            getSensitiveWordOfDocPropertys: function(docPropertys) {
                var deffer = $q.defer();
                getSensitiveWordOfDocPropertys(docPropertys).then(function(data) {
                    deffer.resolve(data);
                });
                return deffer.promise;
            },

            /**
             * [markSensitiveWord description]
             * @param   {[type]}  htmlContent     [htmlContent description]
             * @param   {[type]}  sensitiveWords  [sensitiveWords description]
             * @param   {[type]}  isPopover       [isPopover description]
             * @param   {[type]}  loopHandle      [loopHandle description]
             * @return  {[type]}                  [return description]
             */
            markSensitiveWord: function(htmlContent, sensitiveWords, isPopover, loopHandle) {
                return markSensitiveWord(htmlContent, sensitiveWords, isPopover, loopHandle);
            },

            /**
             * [replaceStrWithoutHtml description]替换敏感词为带颜色标签的敏感词
             * @param  {[string]} htmlContent [description]正文
             * @param  {[string]} sensitiveWord [description]敏感词
             * @return {[obj]}  obj    [description]返回敏感词对象数组
             */
            replaceStrWithoutHtml: function(htmlContent, sensitiveWord) {
                return replaceStrWithoutHtml(htmlContent, sensitiveWord);
            },

            /**
             * [checkAndMarkSensitiveWord description]检测并标记敏感词
             * @param  {[string]} words [description]html被检测字符串
             * @return {[string]}  checkedWords    [description] 检测完成的字符串
             */
            checkAndMarkSensitiveWord: function(words) {
                var deffer = $q.defer();
                var checkedWords = '';
                if (words === '' || angular.isUndefined(words)) {
                    deffer.resolve(words);
                } else {
                    getSensitiveWordOfContent(words).then(function(array) {
                        checkedWords = markSensitiveWord(words, array, false);
                        deffer.resolve(checkedWords);
                    });
                }
                return deffer.promise;
            },

            /**
             * [SensitiveWordsAndCareful description] 敏感词和政审 有政审权限的用户和没有政审权限的用户对于敏感词稿件签发的不同出路
             * @param   {[array]}  checkDrafts          [checkDrafts description] 需要被校验的稿件列表
             * @param   {[boolean]}  wetherLockDraft    [wetherLockDraft description] 是否再次锁定稿件  兼容编辑页
             * @param   {[string]}  MediaType           [MediaType description] 稿件渠道 APP 1 ,Website 2, baozhi 3, wechat 4,weibo 5
             * @param   {[type]}  queryTitleContent     [queryTitleContent description] 是否显示提示内容,默认是显示(true)
             * @return  {[promise]}                     [return description]
             */
            SensitiveWordsAndCareful: function(checkDrafts, wetherLockDraft, MediaType, queryTitleContent) {
                var deffer = $q.defer();
                // 如果不传参数 queryTitleContent, queryTitleContent默认为true
                if (angular.isUndefined(queryTitleContent)) {
                    queryTitleContent = true;
                }
                var isHasSensitiveWords = 0;
                for (var i = 0; i < checkDrafts.length; i++) {
                    if (checkDrafts[i].ISCONTAINSENSITIVEWORDS == '1') {
                        isHasSensitiveWords++;
                    }
                }
                if (isHasSensitiveWords !== 0) {
                    whetherPoliticalAuthority(MediaType, checkDrafts[0].METADATAID).then(function(flag) {
                        var title =
                            isHasSensitiveWords === checkDrafts.length ? '检测到敏感词，是否继续签发？' : '部分稿件检测到有敏感词，是否继续签发？';
                        var content =
                            isHasSensitiveWords === checkDrafts.length
                                ? '注：如点击确定，稿件将等待敏感词审核完成之后才会正式签发。'
                                : '注：如点击确定，含敏感词的稿件将等待敏感词审核完成之后才会正式签发，不含敏感词的稿件将直接签发。';
                        if (flag) {
                            // 如果有政审权限，则置空content
                            content = '';
                        }
                        // 兼容传入参数为string或boolean
                        if (queryTitleContent.toString() == 'false') {
                            content = '';
                        }
                        modalDialog.alertType(
                            title,
                            content,
                            'warning',
                            true,
                            function() {
                                deffer.resolve();
                            },
                            function() {
                                if (angular.isDefined(wetherLockDraft) && wetherLockDraft) {
                                    editIsLock.lockDraft(checkDrafts[0].METADATAID);
                                }
                            }
                        );
                    });
                } else {
                    deffer.reject();
                }
                return deffer.promise;
            },

            /**
             * [SensitiveWordsAndCarefulTiming description]敏感词和政审 有政审权限的用户和没有政审权限的用户对于敏感词稿件签发的不同出路，用于定时签发前的判断
             * @param  {[array]} checkDrafts [description]需要被校验的稿件列表
             * @param  {[boolean]} wetherLockDraft [description]是否再次锁定稿件  兼容编辑页
             * @return {[string]}  checkedWords    [description] 检测完成的字符串
             */
            SensitiveWordsAndCarefulTiming: function(checkDrafts, wetherLockDraft) {
                var deffer = $q.defer();
                var isHasSensitiveWords = 0;
                for (var i = 0; i < checkDrafts.length; i++) {
                    if (checkDrafts[i].ISCONTAINSENSITIVEWORDS == '1') {
                        isHasSensitiveWords++;
                    }
                }
                if (isHasSensitiveWords !== 0) {
                    var title =
                        isHasSensitiveWords === checkDrafts.length
                            ? '稿件内容包含敏感词，不允许定时签发'
                            : '稿件内容包含敏感词，重新选择不含敏感词的稿件进行定时签发';
                    modalDialog.alertType(
                        title,
                        '',
                        'warning',
                        false,
                        function() {
                            if (angular.isDefined(wetherLockDraft) && wetherLockDraft) {
                                editIsLock.lockDraft(checkDrafts[0].METADATAID);
                            }
                        },
                        function() {
                            if (angular.isDefined(wetherLockDraft) && wetherLockDraft) {
                                editIsLock.lockDraft(checkDrafts[0].METADATAID);
                            }
                        }
                    );
                } else {
                    deffer.reject();
                }
                return deffer.promise;
            },

            /**
             * [markSensitiveWordCompare description] 标记并比较编辑器中的敏感词
             * @param {object} [scope] [description] 调用区域的作用域
             * @return {[type]}    [description]
             */
            markSensitiveWordCompare: function(scope) {
                scope.saveHtmlContent = '';
                if (window.UE) {
                    scope.ue = UE.getEditor('ueditor');
                    initData();
                    contentChange();
                }

                /**
                 * [contentChange description] 监听编辑器内容变化
                 * @return  {[type]}  [return description]
                 */
                function contentChange() {
                    scope.ueditorListener = function(e) {
                        initData();
                    };
                    scope.ueditorKeyUp = scope.ue.addListener('keyup', scope.ueditorListener);
                    scope.contentChange = scope.ue.addListener('mouseup', scope.ueditorListener);
                    scope.$on('$destroy', function() {
                        scope.ue.removeListener('keyup', scope.ueditorListener);
                        scope.ue.removeListener('mouseup', scope.ueditorListener);
                    });
                }

                /**
                 * [initData description] 初始化
                 * @return {[type]} [description]
                 */
                function initData() {
                    var htmlcontent = scope.ue.getContent();
                    markSensitiveWord(htmlcontent);
                }

                /**
                 * [markSensitiveWord description] 标记敏感词
                 * @param  {[type]} htmlContent [description]
                 * @return {[type]}             [description]
                 */
                function markSensitiveWord(htmlContent) {
                    return;
                }
                // 获取字符串在文章中出现的次数
            },

            /**
             * [leaveCheckoutMode description] 编辑器退出校验模式
             * @param  {[object]} scope      [description] 调用区域的作用域
             * @return {[type]} [description]
             */
            leaveCheckoutMode: function(scope) {
                if (window.UE) {
                    var htmlContent = scope.ue.getContent();
                    htmlContent = clearMarkSensitiveWord(htmlContent);
                    scope.ue.setContent(htmlContent);
                }
            },
        };
    },
]);
